export default __webpack_public_path__ + "static/media/29.acd96713.png";